module.exports = new __parcel__URL__("shop_machines_space_elixir_mine_v2.f0e2af5b.png").toString();